import estimateApproval from './estimate-approvals/all';
import pursuitRequestForm from "./pursuit-request-form/all";
import bondRequests from "./bond-requests/all";

export default function (nameController, nameAction, namePage) {
    if (nameController === 'estimateapproval') estimateApproval(nameAction, namePage);
    if (nameController === 'pursuitrequestform') pursuitRequestForm(nameAction, namePage);
    if (nameController === 'bondrequests') bondRequests(nameAction, namePage);
}